const CoffeeIcon = () => {
  return (
    <svg
      width="69"
      height="64"
      viewBox="0 0 69 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="50"
        y="27"
        width="17"
        height="16"
        rx="7"
        stroke="#002133"
        strokeWidth="4"
      />
      <path
        d="M2.00242 31C2.00242 26.0294 6.03185 22 11.0024 22H47C51.9706 22 56 26.0294 56 31V39.2178C56 39.392 55.9948 39.5009 55.9844 39.5856C55.8897 40.3623 55.3709 43.5906 52.839 49.3372C49.2198 57.5513 39.2966 62 28.8054 62C18.3142 62 8.391 57.5513 4.77182 49.3372C2.26294 43.643 2.02288 40.4785 2.0019 39.7703C1.99888 39.6685 1.99968 39.5916 2.0008 39.4847C2.00154 39.414 2.00242 39.3303 2.00242 39.2175V31Z"
        fill="white"
        stroke="#002133"
        strokeWidth="4"
      />
      <path
        d="M11.3027 43.0949C12.802 48.5603 15.5865 51.447 20.6901 53.7916"
        stroke="#002133"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M15.166 9.20312C19.5893 11.5001 19.8766 15.4364 14.5127 17.406"
        stroke="#002133"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M16.8667 10.3828C12.4001 8.15096 12.0376 4.21951 17.3631 2.17156"
        stroke="#002133"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M27.3916 9.20312C31.8149 11.5001 32.1022 15.4364 26.7383 17.406"
        stroke="#002133"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M29.0918 10.3828C24.6252 8.15096 24.2627 4.21951 29.5882 2.17156"
        stroke="#002133"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M40.8813 9.20312C45.3046 11.5001 45.592 15.4364 40.2281 17.406"
        stroke="#002133"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M42.5815 10.3828C38.115 8.15096 37.7524 4.21951 43.0779 2.17156"
        stroke="#002133"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CoffeeIcon;
